<vs-dialog
  [config]="{
    dialogContainerClass: 'w-[350px] sm:w-[500px] max-w-[600px]',
    disableBackdropDismiss: submitting,
  }"
  (closed)="resetForm()"
>
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      hideCloseButton: submitting,
      icon: 'bank-note-01',
      iconTheme: 'primary',
      title: title,
      subtitle: subtitle,
      showDivider: true,
    }"
  ></vs-dialog-header>

  <div *ngIf="loading" class="flex items-center justify-center gap-2 py-10 text-sm text-gray-600">
    <vs-icon name="refresh-cw-02" class="animate-spin"></vs-icon>
    Loading gateway...
  </div>

  <form *ngIf="canManage && !loading" class="flex flex-col gap-4 pt-6" [formGroup]="form" (ngSubmit)="confirm()">
    <vs-form-field
      appearance="responsive"
      [config]="{label: 'Instance name', description: 'Use a unique name that identifies this merchant account.'}"
    >
      <vs-input-container>
        <input type="text" formControlName="name" autocomplete="off" placeholder="Example: Primary checkout" />
      </vs-input-container>
      <span slot="hint" class="text-danger" *ngIf="form.controls.name.invalid && form.controls.name.touched">
        Enter a gateway instance name.
      </span>
    </vs-form-field>

    <vs-form-field *ngIf="!editMode" appearance="responsive" [config]="{label: 'Provider'}">
      <vs-select vsInput formControlName="provider" placeholder="Select a payment provider">
        <li *ngFor="let option of providerOptions" vs-select-option [value]="option.value">{{ option.label }}</li>
      </vs-select>
    </vs-form-field>

    <div *ngIf="editMode && selectedGateway" class="grid grid-cols-2 gap-x-4 gap-y-2 rounded-lg bg-gray-50 p-4">
      <span class="text-sm font-medium text-gray-600">Provider</span>
      <span class="text-sm text-gray-900">{{ providerLabel }}</span>
      <span class="text-sm font-medium text-gray-600">Lifecycle state</span>
      <span class="text-sm text-gray-900">{{ formatStatus(selectedGateway.status) }}</span>
      <span class="text-sm font-medium text-gray-600">Default gateway</span>
      <span class="text-sm text-gray-900">{{ selectedGateway.isDefault ? 'Yes' : 'No' }}</span>
      <span class="text-sm font-medium text-gray-600">Last verified</span>
      <span class="text-sm text-gray-900">{{ (selectedGateway.verifiedAt | date: 'medium') || 'Not verified' }}</span>
    </div>

    <div *ngIf="editMode" class="flex flex-col gap-2 rounded-lg border border-gray-200 p-4">
      <label class="flex cursor-pointer items-start gap-3">
        <input
          vsInput
          type="checkbox"
          appearance="toggle"
          [checked]="form.controls.replaceCredentials.value"
          (change)="setReplaceCredentials($any($event.target).checked)"
        />
        <span class="flex flex-col gap-1">
          <span class="text-sm font-medium text-gray-900">Replace credentials</span>
          <span class="text-xs text-gray-600">
            Saved credentials are write-only and cannot be viewed. Leave this off to keep them unchanged.
          </span>
        </span>
      </label>
    </div>

    <div *ngIf="showCredentialFields" class="flex flex-col gap-4">
      <p class="text-sm text-gray-600">
        The provider will validate these credentials before they are saved. They will not be shown again.
      </p>

      <vs-form-field appearance="responsive" [config]="{label: providerDefinition.accountNameLabel}">
        <vs-input-container>
          <input
            type="text"
            formControlName="accountName"
            autocomplete="off"
            [placeholder]="providerDefinition.accountNamePlaceholder"
          />
        </vs-input-container>
        <span
          slot="hint"
          class="text-danger"
          *ngIf="form.controls.accountName.invalid && form.controls.accountName.touched"
        >
          Enter the provider account identifier.
        </span>
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{label: providerDefinition.secretLabel}">
        <vs-input-container>
          <input
            type="password"
            formControlName="transactionKey"
            autocomplete="new-password"
            [placeholder]="providerDefinition.secretPlaceholder"
          />
        </vs-input-container>
        <span
          slot="hint"
          class="text-danger"
          *ngIf="form.controls.transactionKey.invalid && form.controls.transactionKey.touched"
        >
          Enter the complete provider transaction key.
        </span>
      </vs-form-field>
    </div>

    <div class="flex flex-col-reverse items-center gap-3 pt-2 sm:flex-row sm:justify-end">
      <button
        vs-button
        type="button"
        class="w-full sm:w-auto"
        appearance="outline"
        [disabled]="submitting"
        (click)="closeDialog()"
      >
        Cancel
      </button>
      <button vs-button type="submit" class="w-full sm:w-auto" theme="primary" [disabled]="!canSubmit">
        {{ submitting ? 'Validating and saving...' : editMode ? 'Save changes' : 'Add gateway' }}
        <vs-icon *ngIf="submitting" name="refresh-cw-02" class="animate-spin"></vs-icon>
      </button>
    </div>
  </form>
</vs-dialog>
